import script from "./DateRangeSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateRangeSelect.vue?vue&type=script&setup=true&lang=ts"

import "./DateRangeSelect.vue?vue&type=style&index=0&id=0ca3636d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ca3636d"]])

export default __exports__